import { DefineComponent } from 'vue';
import { PagesPath } from '@core/utils/pages-paths';

const pagesPaths: PagesPath[] = [
    [
        import.meta.glob<DefineComponent>(
            '/vendor/kibokosrl/kiboko-backoffice-newsletter/resources/js/Pages/**/*.vue',
        ),
        (name) =>
            `/vendor/kibokosrl/kiboko-backoffice-newsletter/resources/js/Pages/${name}.vue`,
    ],
];

export default pagesPaths;
